"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = _interopRequireDefault(require("./utils/colors"));

require("../css/progressbar.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(_ref) {
  var color = _ref.color,
      value = _ref.value;
  var barColor = _colors.default.indexOf(color) !== -1 ? color : ProgressBar.defaultProps.color;

  var fixPercentage = function fixPercentage(percent) {
    if (percent < 0) {
      return 0;
    }

    if (percent > 100) {
      return 100;
    }

    return percent;
  };

  var percentage = fixPercentage(value);
  var compensation = percentage < 10 ? 2 : 3;
  var percentagePadding = percentage < 2 ? 96 : fixPercentage(100 - percentage - compensation);
  return _react.default.createElement("div", {
    className: "vn-progress-bar"
  }, _react.default.createElement("div", {
    className: "vn-progress-bar__bar vn-background-color--".concat(barColor),
    style: {
      width: "".concat(percentage, "%")
    }
  }), _react.default.createElement("div", {
    className: "vn-progress-bar__background-bar vn-background-color--neutral"
  }), _react.default.createElement("span", {
    className: "vn-progress-bar__percentage",
    style: {
      paddingRight: "".concat(percentagePadding, "%")
    }
  }, "".concat(value, "%")));
};

ProgressBar.propTypes = {
  color: _propTypes.default.oneOf(_colors.default),
  value: _propTypes.default.number
};
ProgressBar.defaultProps = {
  color: 'accent',
  value: 0
};
ProgressBar.displayName = 'ProgressBar';
var _default = ProgressBar;
exports.default = _default;